<mat-form-field
  appearance="outline"
  class="form-field"
  [class.none-pointer-events]="!isEditModeActive()"
>
  <mat-label>Комментарий</mat-label>
  <textarea
    matInput
    cdkTextareaAutosize
    type="text"
    cdkAutosizeMinRows="4"
    cdkAutosizeMaxRows="7"
    [(ngModel)]="designBlockData().comment"
    (blur)="handleUpdateComment()"
  ></textarea>
</mat-form-field>
@if (isActiveUploadFile()) {
  <app-file-upload-card
    class="card-upload"
    [fileUploadParams]="{
      recordId: designBlockData().id,
      parentId: designBlockData().id,
      type: listingEntityFileType(),
      entityFileType: listingEntityFileType()
    }"
    [isEditModeActive]="isEditModeActive()"
    [remainingFileSlots]="remainingFileSlots()"
    (attachFile)="handleAttachFile($event)"
  />
}
